<template>
  <div>
    <SmsSender
      :mobileNumber="driverPhoneNumber"
      :contactName="driverName"
      :messageDialog="driverMessageDialog"
      :messageType="2"
      @closeSmsSender="closeSmsSender">
    </SmsSender>
    <div v-for="(bus, index) in busRuns"
      :key="bus.busId"
      :class="cssClass(index)"
      class="busRunControl">
      <v-card v-if="!isDriverView || !!isDriverView && bus.busRunBookings.length>0">
        <v-card-title>{{getBusTitle(bus)}}
          <v-btn
            class="ml-2"
            v-if="bus.driverContactPhoneNumber"
            :title="`send text message - ${ bus.driverContactPhoneNumber }`"
            color="primary"
            dark
            x-small
            @click="sendDriverSms(bus)">
            <v-icon small>mdi-cellphone-message</v-icon>
          </v-btn>
          <v-btn class="ml-2"
            v-if="bus.driverContactPhoneNumber"
            color="primary"
            dark
            x-small
            :title="`call - ${ bus.driverContactPhoneNumber }`"
            :href="`tel:${ bus.driverContactPhoneNumber }`">
            <v-icon small>mdi-cellphone-wireless</v-icon>
          </v-btn>
        </v-card-title>
        <v-text-field
            v-if="directionType==1"
            v-model="bus.commentDept"
            maxlength="150"
            placeholder="Daily comment"
            hide-details="auto">
        </v-text-field>
        <v-text-field
            v-if="directionType==2"
            v-model="bus.commentArrive"
            maxlength="150"
            placeholder="Daily comment"
            hide-details="auto">
        </v-text-field>
        <bus-run-bookings-control
          :pickupTimes="pickupTimes"
          :index="index"
          :busId="bus.busId"
          :items="bus.busRunBookings"
          :busList="busList"
          :headers="directionType === 1 ? toAirportHeaders : fromAirportHeaders"
          :directionType="directionType"
          :bookingDate="bookingDate"
          :isDriverView="!!isDriverView">
        </bus-run-bookings-control>
      </v-card>
    </div>
  </div>
</template>

<script>
import BusRunBookingsControl from '@/modules/bus-run-manager/components/BusRunBookingsControl.vue';
import SmsSender from '@/components/SmsSender.vue';

export default {
  name: 'BusRunBookingsControl',
  props: {
    pickupTimes: {
      type: Array,
      default: undefined,
    },
    directionType: {
      type: Number,
      default: undefined,
    },
    directionDescription: {
      type: String,
      default: undefined,
    },
    busRuns: {
      type: Array,
      default: undefined,
    },
    busList: {
      type: Array,
      default: undefined,
    },
    bookingDate: {
      type: String,
      default: undefined,
    },
    isDriverView: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'bus-run-bookings-control': BusRunBookingsControl,
    SmsSender,
  },
  data: () => ({
    menu: false,
    driverMessageDialog: false,
    driverPhoneNumber: undefined,
    driverName: undefined,
    toAirportHeaders: [ // departures
      { text: 'Pickup Time', value: 'pickupTime', sortable: false },
      { text: 'Completed', value: 'departStatus', sortable: false },
      { text: 'Bus', value: 'toAirportBusId', sortable: false },
      {
        text: 'Suburb',
        value: 'suburb',
        sortable: false,
        width: 100,
      },
      {
        text: 'Name',
        value: 'fullName',
        sortable: false,
      },
      {
        text: 'Address',
        value: 'formattedAddress',
        sortable: false,
        width: 125,
      },
      {
        text: 'PAX',
        value: 'pax',
        sortable: false,
        width: 30,
      },
      {
        text: 'Paid',
        value: 'hasPaid',
        sortable: false,
        width: 30,
      },
      { text: 'Fare', value: 'fare', sortable: false },
      {
        text: 'Phone #',
        value: 'phoneNumber',
        sortable: false,
        width: 85,
      },
      {
        text: 'Number',
        value: 'mobileNumber',
        sortable: false,
        width: 85,
      },
      { text: 'Booking Ref', value: 'bookingId', sortable: false },
      { text: 'Time to Airport', value: 'timeToAirport', sortable: false },
      { text: 'Flight', value: 'flightDetails', sortable: false },
      {
        text: 'Notes',
        value: 'commentsInbounds',
        sortable: false,
        width: 200,
      },
      {
        text: 'Actions',
        value: 'actions',
        sortable: false,
        width: 30,
      }],
    fromAirportHeaders: [ // arrivals
      { text: 'Status', value: 'arrivalStatus', sortable: false },
      { text: 'Bus', value: 'fromAirportBusId', sortable: false },
      {
        text: 'Suburb',
        value: 'suburb',
        sortable: false,
        width: 100,
      },
      {
        text: 'Name',
        value: 'fullName',
        sortable: false,
      },
      {
        text: 'Address',
        value: 'formattedAddress',
        sortable: false,
        width: 125,
      },
      {
        text: 'PAX',
        value: 'pax',
        sortable: false,
        width: 30,
      },
      {
        text: 'Paid',
        value: 'hasPaid',
        sortable: false,
        width: 30,
      },
      { text: 'Fare', value: 'fare', sortable: false },
      {
        text: 'Phone #',
        value: 'phoneNumber',
        sortable: false,
        width: 85,
      },
      {
        text: 'Number',
        value: 'mobileNumber',
        sortable: false,
        width: 85,
      },
      { text: 'Booking Ref', value: 'bookingId', sortable: false },
      { text: 'Flight', value: 'flightDetails', sortable: false },
      {
        text: 'Notes',
        value: 'commentsOutbounds',
        sortable: false,
        width: 200,
      },
      { text: 'Actions', value: 'actions', sortable: false }],
  }),
  methods: {
    cssClass(index) {
      return `bus${index}`;
    },
    getBusTitle(bus) {
      const driverName = bus.driverName ? ` - ${bus.driverName}` : '';
      const nightRunText = bus.isNightRun ? '**NIGHT RUN**' : '';
      return `${bus.busName}${driverName}${nightRunText}`;
    },
    sendDriverSms(bus) {
      this.driverName = bus.driverName;
      this.driverPhoneNumber = bus.driverContactPhoneNumber;
      this.driverMessageDialog = true;
    },
    closeSmsSender() {
      this.driverPhoneNumber = undefined;
      this.driverPhoneNumber = undefined;
      this.driverMessageDialog = false;
    },
  },
};

</script>
<style>
  .busRunControl {
    padding-bottom: 0.75rem;
  }
  .busRunControl .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-size: 0.7rem;
  }
  .busRunControl.bus0 > .v-card.v-sheet.theme--light {
    background-color: #DDDDDD;
  }
  .busRunControl.bus0 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #C0C0C0;
  }

  .busRunControl.bus1 > .v-card.v-sheet.theme--light {
    background-color: #BBE8FF;
  }
  .busRunControl.bus1 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #6CCCFF
  }

  .busRunControl.bus2 > .v-card.v-sheet.theme--light {
    background-color: #BDFFBB;
  }
  .busRunControl.bus2 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #6BE79F
  }

  .busRunControl.bus3 > .v-card.v-sheet.theme--light {
    background-color: #FFBBBB;
  }
  .busRunControl.bus3 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #F38B8B
  }

  .busRunControl.bus4 > .v-card.v-sheet.theme--light {
    background-color: #F9F7B0;
  }
  .busRunControl.bus4 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #F4DA8A
  }

  .busRunControl.bus5 > .v-card.v-sheet.theme--light {
    background-color: #DCD1F3;
  }
  .busRunControl.bus5 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #B8A2E8
  }

  .busRunControl.bus6 > .v-card.v-sheet.theme--light {
    background-color: #DCDCB8;
  }
  .busRunControl.bus6 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #BEBE7C
  }

  .busRunControl.bus7 > .v-card.v-sheet.theme--light {
    background-color: #B0ECB0;
  }
  .busRunControl.bus7 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #72DC72
  }

  .busRunControl.bus8 > .v-card.v-sheet.theme--light {
    background-color: #98EFDE;
  }
  .busRunControl.bus8 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #37E1BF
  }

  .busRunControl.bus9 > .v-card.v-sheet.theme--light {
    background-color: #FFCECE;
  }
  .busRunControl.bus9 .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    background-color: #FF9999
  }

  .busRunControl .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    color: #000;
  }
  .busRunControl .v-card__title {
    font-size: 1rem;
    line-height: 1rem;
    padding: 0.5rem;
  }

  .busRunControl .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
  .busRunControl .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
  .busRunControl .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.7rem !important;
    letter-spacing: .0333333333em;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .busRunControl .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    padding-bottom: 0;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .busRunControl .v-text-field {
    padding-top: 0;
    margin-top: 0;
  }
  .busRunControl .v-card__title {
    padding-bottom: 0;
  }
</style>
